import React from "react";
import { REGISTRATION_FEE_DOLLARS } from "../constants/sealRegistrationConstants";

interface SealPaymentSummaryProps {
  donationAmount: number;
}

export const SealPaymentSummary: React.FC<SealPaymentSummaryProps> = ({
  donationAmount,
}) => {
  const total = REGISTRATION_FEE_DOLLARS + donationAmount;

  return (
    <div className="seal-payment-summary">
      <div className="seal-payment-summary-row">
        <span>OVR Seal registration fee</span>
        <span>US ${REGISTRATION_FEE_DOLLARS.toFixed(2)}</span>
      </div>
      <div className="seal-payment-summary-row">
        <span>Optional additional donation</span>
        <span>US ${donationAmount.toFixed(2)}</span>
      </div>
      <div className="seal-payment-summary-total">
        <span>Total</span>
        <span>US ${total.toFixed(2)}</span>
      </div>
    </div>
  );
};
